export default "__VITE_ASSET__gExUBMCK__"